export const colors = {
  base: '#000000',
  contrast: '#ffffff',
  accent1: '#bf0a0a',
  accent2: '#373a3c',
  accent3: '#2d2d2d',
  accent4: '#757575',
  accent5: '#e43027',
  customAccent6: '#959393',
  customAccent7: '#070707',
  black: '#000000',
  white: '#ffffff'
} as const

export type ColorKey = keyof typeof colors
